import { saveAs } from 'file-saver'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { Card } from '@/components/Elements'
import { Checkbox, DatePicker, FileInput, Input, Select } from '@/components/Form'
import { useAdminFunction } from '@/features/adminFunction/useAdminFunction'
import { OfferDocumentTypes } from '@/features/offers/constants'
import useUser from '@/features/users/useUser'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { isNullish } from '@/utils/helper'
import { Box, Button, Flex } from '@chakra-ui/react'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import { ConfigType } from '../../config.enum'
import useConfig from '../../useConfig'
import useOfferList from '@/features/offers/hooks/useOfferList'

const SignCostSheetCard = () => {
  const methods = useForm({
    defaultValues: {
      fileName: 'signed_offer_cost_sheet',
    },
  })
  const dispatch = useDispatch()
  const { useSignCostSheet } = useAdminFunction()
  const { useOfferOptions } = useOfferList()

  //Translated Variables

  const signCostSheet = useSignCostSheet()
  const { data: offerOptions } = useOfferOptions({})

  const onSubmit = async ({ offerId, costSheet, offerStage, signDate, fileName }) => {
    if (!fileName) {
      toast.error('Missing File Name')
      return
    }

    if (!costSheet) {
      toast.error('Missing Uploaded File')
      return
    }

    if (isNullish(offerStage) || offerStage === '') {
      toast.error('Missing Type')
      return
    }

    try {
      dispatch(showLoadingOverlay())
      const payload = {
        costSheetId: costSheet?._id,
        offerStage: offerStage,
        signDate: signDate,
        offerId: offerId,
      }

      const response = await signCostSheet.mutateAsync(payload)

      const blob = new Blob([response])

      saveAs(blob, `${fileName}.pdf`)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }
  return (
    <Card title="Sign Cost Sheet">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box p={5}>
            <Flex direction="column" gap="3">
              <Input name="fileName" label="File Name" isRow />
              <Select name="offerId" label="Offer " isRow options={offerOptions} />
              <FileInput
                label="Cost Sheet"
                name="costSheet"
                fileType={OfferDocumentTypes.DOCUMENTS_INTERNAL_COSTSHEET}
                canUpload
                isRequired
                isRow
              />
              <DatePicker name="signDate" label="Sign Date (DD-MMM-YYYY)" isRow />
              <Select
                name="offerStage"
                label="Type"
                defaultValue={'maintenance'}
                isRow
                options={[
                  { label: 'Quotation', value: 'quotation' },
                  { label: 'Booking', value: 'booking' },
                ]}
              />
            </Flex>
            <Button mt="6" colorScheme="blue" type="submit">
              Sign
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Card>
  )
}

export default SignCostSheetCard
